import { Controller, ControllerRenderProps, FieldValues, useFormContext } from 'react-hook-form'
import { Calendar as MuiCalendar } from '../../inputs'
import { useCallback } from 'react'
import { ErrorMessage } from '../ErrorMessage'

type NullableDate = Date | null

interface Props {
  customerTimeZone: string
  defaultValue?: Date
  name: string
  onChange?: any
  onMonthChange?: any
  renderDay?: any
  maxDate?: Date
}

// const errorMessage = 'Time must be in HH:MM AM/PM format'

type Field = ControllerRenderProps<FieldValues, string>

const Calendar = ({ customerTimeZone, defaultValue, name, onChange: onChangeProp, onMonthChange: onMonthChangeProp, ...rest }: Props) => {
  const {
    control,
    formState: { errors },
    clearErrors,
  } = useFormContext()

  const error = errors?.[name]
  const hasError = Boolean(error)

  const render = ({ field }: { field: Field }) => {
    const { onChange: onChangeFormHandler } = field
    const onChangeProxy = useCallback(
      (date: NullableDate) => {
        if (onChangeProp) {
          onChangeProp(date)
        }
        clearErrors()
        onChangeFormHandler(date)
      },
      [onChangeFormHandler, onChangeProp]
    )
    const onMonthChangeProxy = useCallback(
      (date: NullableDate) => {
        if (onMonthChangeProp) {
          onMonthChangeProp(date)
        }
        clearErrors()
      },
      [onMonthChangeProp]
    )
    return (
      <>
        <MuiCalendar {...rest} {...field} customerTimeZone={customerTimeZone} onChange={onChangeProxy} onMonthChange={onMonthChangeProxy} />
        {hasError && (
          <ErrorMessage
            message={error.message}
            style={{
              display: 'grid',
              gridAutoFlow: 'column',
              placeContent: 'center',
            }}
          />
        )}
      </>
    )
  }

  return <Controller defaultValue={defaultValue} control={control} name={name} render={render} />
}

export { Calendar }
